// extracted by mini-css-extract-plugin
export default {"notifier":"NotificationContext_notifier__yROn1","notification":"NotificationContext_notification__8SpiC"};